import call from "./call";
import { ExpertFormState, ExpertResponse } from "../Models/expert";

export const createExpert = async (
  newExpert: ExpertFormState
): Promise<void> => {
  const { data } = await call.post(
    "/v1/expert/order/",
    {
      name: newExpert.expertName,
      professional_background: newExpert.professionalBackground,
      key_expertise: newExpert.keyExpertise,
      training_and_certifications: newExpert.trainingAndCertifications,
      process_mastery: newExpert.processMastery,
      primary_responsibilities: newExpert.primaryResponsibilities,
      problem_solving_abilities: newExpert.problemSolvingAbilities,
      knowledge_depth: newExpert.knowledgeDepth,
      knowledge_base_links: newExpert.knowledgebase,
      trends_links: newExpert.trends,
      model_behaviour: newExpert.modelBehavior,
    },
    {
      withCredentials: true,
      snack: {
        success: "expertForm.createdSuccess",
        403: "expertForm.noAccess",
        error: "expertForm.errorCreating",
      },
    }
  );
  return data;
};

export const getExperts = async (
  alanCredentialsId?: number | null
): Promise<ExpertResponse> => {
  const response = await call.get<ExpertResponse>("/v1/expert/", {
    params: {
      alan_credentials_id: alanCredentialsId ?? undefined,
    },
    snack: {
      error: "expertForm.expertsFetchError",
    },
  });
  return response.data;
};

export const getSingleExpert = async (expertId: string) => {
  const response = await call.get(`/v1/expert/${expertId}/`, {
    snack: {
      error: "expertForm.fetchExpertError",
    },
  });
  return response.data;
};

export const getExpertsForWorkspaceCredentials = async (
  workspaceId?: number
): Promise<ExpertResponse> => {
  const response = await call.get<ExpertResponse>("/v1/expert/workspace/", {
    params: workspaceId ? { workspace_id: workspaceId } : {},
    snack: { error: "expertForm.expertsFetchError" },
  });
  return response.data;
};
